import { UserFeatureFlag } from '@@types/api.types';
import { ReportLayout } from '@components/layouts/report.layout';
import { ExternalLink } from '@components/shared/external-link.component';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { THREADS_SRC, THREADS_VIEWPORT_ANCHOR_ID } from '@components/shared/threads-iframe-manager.component';
import { Tile } from '@components/shared/tile.component';
import { useGetCurrentUser } from '@queries/users.query';
import { routes } from '@routes';
import React from 'react';
import { Navigate } from 'react-router-dom';

export const ThreadsPage: React.FC = () => {
  const { data: user, isPending } = useGetCurrentUser();
  const hasThreadsTool = user?.featureFlags?.includes(UserFeatureFlag.THREADS_TOOL);

  if (!isPending && !hasThreadsTool) {
    return <Navigate to={routes.home.path} />;
  }

  return (
    <PageviewTracker>
      <HelmetWrapper title="Threads" />
      <ReportLayout>
        <Tile
          className="h-[calc(100svh-var(--impersonation-banner-height,0px)-2rem)]"
          contentClassName="h-full"
          header={{
            actions: (
              <ExternalLink
                className="text-sm"
                href={THREADS_SRC}
              >
                Open directly
              </ExternalLink>
            ),
            title: 'Threads',
          }}
          isLoading={isPending}
        >
          <div
            className="h-full min-h-160"
            id={THREADS_VIEWPORT_ANCHOR_ID}
          />
        </Tile>
      </ReportLayout>
    </PageviewTracker>
  );
};
